import { isEmptyArray } from 'formik';
import moment from 'moment-timezone';
import { validatePassword } from './passwordValidation';
import * as utils from "../../_metronic/utils/utils";
import * as authCrud from "../crud/auth.crud";
import { Constants } from "./Constants";

export const createFormikValidation = (formMap, values) => {
	const errors = {};

	for (let [key, value] of formMap) {
		if ((!values[key] && values[key] !== 0 ) || (isEmptyArray(values[key]))) {
			errors[key] = "O campo " + value + " é obrigatório."
		} else if (key === 'email' && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values[key])) {
			errors[key] = "Você precisa informar um e-mail válido.";
		} else if ((key === 'cli_cpf') && !validaCpf(values[key])) {
			errors[key] = "O CPF informado é inválido.";
		} else if (key === 'password') {
			const passwordValidation = validatePassword(values[key]);
			if (!passwordValidation.isValid) {
				errors[key] = passwordValidation.errors[0];
			}
		}
	}

	return errors;
};

export const validaCpf = (cpf) => {
	var add = 0;
	var rev = 0;

	cpf = cpf.replace(/[^\d]+/g, '');
	if (cpf == '') return false;

	if (cpf.length != 11) return false;

	for (var i = 0; i < 9; i++) {
		add += parseInt(cpf.charAt(i)) * (10 - i);
	}

	rev = 11 - (add % 11);

	if (rev == 10 || rev == 11) {
		rev = 0;
	}
	if (rev != parseInt(cpf.charAt(9))) {
		return false;
	}

	add = 0;

	for (var j = 0; j < 10; j++) {
		add += parseInt(cpf.charAt(j)) * (11 - j);
	}

	rev = 11 - (add % 11);

	if (rev == 10 || rev == 11) {
		rev = 0;
	}

	if (rev != parseInt(cpf.charAt(10))) {
		return false;
	}

	return true;
};

export const shallowEqual = (object1, object2) => {
	const keys1 = Object.keys(object1);
	const keys2 = Object.keys(object2);

	if (keys1.length !== keys2.length) {
		return false;
	}

	for (let key of keys1) {
		if (object1[key] !== object2[key]) {
			return false;
		}
	}

	return true;
};

export const formatCepInput = input => {
	let value = input.target.value;

	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{5})(\d)/, "$1-$2");

	input.target.value = value;

	return input;
};

export const formatBRLInput = input => {
	input.target.value = Number(input.target.value.toString().replace(/[^0-9]/g, '')) / 10 ** 2;

	input.target.value = formatBRL(input.target.value);

	return input;
};

export const formatBRL = value => {
	const formatter = new Intl.NumberFormat('pt-BR', {
		style: 'currency',
		currency: 'BRL',
		minimumFractionDigits: 2
	});

	value = formatter.format(value);

	return value;
};

export const formatIntegerInput = input => {
	if (input.target.value == '') {
		input.target.value = 0;
		return input;
	}

	input.target.value = Number(input.target.value.toString().replace(/[^0-9]/g, ''));
	return input;
};

export const formatPercentageInput = input => {
	if (input.target.value == '') input.target.value = 0;
	input.target.value = Number(input.target.value.toString().replace(/[^0-9]/g, ''));
	if (input.target.value == 0) input.target.value = 0;
	if (input.target.value > 100) input.target.value = '100';
	return input;
};

export const limparMoeda = (valor) => {
	valor = valor.replace("R$", "");
	valor = valor.replace(".", "");
	valor = valor.replace(",", ".");
	// eslint-disable-next-line
	valor = valor.replace('/^\p{Z}+|\p{Z}+$/u', '');
	valor = valor.trim();

	return valor
};

export const clearBRL = (valor) => {
	valor = valor.replace("R$", "");
	valor = valor.replace("%", "");
	valor = valor.replace(".", "");
	valor = valor.replace(",", ".");
	valor = valor.replace('/^\p{Z}+|\p{Z}+$/u', '');
	valor = valor.trim();

	return valor;
};

export const convertToGMT = (date, time, format, toGMT3) => {

	let f_datetime = moment();

	if (date && time) {
		f_datetime = moment(date + ' ' + time);
	} else if (date) {
		f_datetime = moment(date);
	}

	if (toGMT3) {
		switch (localStorage.getItem('timeZone')) {
			case 'GMT-2':
				f_datetime.subtract(1, 'hour');
				break;
			case 'GMT-4':
				f_datetime.add(1, 'hour');
				break;
			case 'GMT-5':
				f_datetime.add(2, 'hours');
				break;
			default:
				break;
		}
	} else {
		switch (localStorage.getItem('timeZone')) {
			case 'GMT-2':
				f_datetime.add(1, 'hour');
				break;
			case 'GMT-4':
				f_datetime.subtract(1, 'hour');
				break;
			case 'GMT-5':
				f_datetime.subtract(2, 'hours');
				break;
			default:
				break;
		}
	}

	return f_datetime.format(format)
};

export const navigateToPainelWithSso = async (path = "/") => {
	try {
		const response = await authCrud.gerarTokenSso();
		
		if(!response.data?.token) throw new Error("Token não recebido");
		
		const baseUrl = Constants.cashbarberFrontendUrl;
		const ssoUrl = `${baseUrl}/auth/sso?token=${response.data.token}`;
			
		if (path && path !== "/") {
			const encodedPath = encodeURIComponent(path);
			window.open(`${ssoUrl}&redirect=${encodedPath}`, '_blank');
		} else {
			window.open(ssoUrl, '_blank');
		}
		return true;

	} catch (error) {
		console.error("Erro ao gerar token SSO para o painel:", error);
		window.open(Constants.cashbarberFrontendUrl + path, "_blank");
		return false;
	}
};